import React from 'react';
import {Entry, TimelineEntry} from './Shared';

export const CustomNoteTimelineEntry = ({entry}) => {
    return (
        <TimelineEntry entry={entry} status="complete" icon="edit">
            <Entry.Title>{entry.note}</Entry.Title>
        </TimelineEntry>
    );
};
